import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faWhatsapp } from "@fortawesome/free-brands-svg-icons";
import './Footer.css';

const Footer = () => {
  const [showTooltip, setShowTooltip] = useState(false);
  const [hoverMessage, setHoverMessage] = useState(false);
  const [currentMessage, setCurrentMessage] = useState("");

  const messages = [
    "Looking for plastic safety eyes in bulk?",
    "Need soft toy eyes supplier in Delhi?",
    "Chat with us for wholesale toy accessories!"
  ];

  useEffect(() => {
    const interval = setInterval(() => {
      const randomMessage = messages[Math.floor(Math.random() * messages.length)];
      setCurrentMessage(randomMessage);
      setShowTooltip(true);
      setTimeout(() => setShowTooltip(false), 5000);
    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const handleHover = () => {
    setHoverMessage(true);
    setTimeout(() => setHoverMessage(false), 3000);
  };

  return (
    <footer className="footer">
      
      <div className="footer-content">

        {/* 🔥 SEO TEXT */}
        <div>
          <strong>
            Plastic Safety Eyes Manufacturer in India | Soft Toy Eyes Supplier Delhi
          </strong>

          <p style={{ marginTop: "10px", fontSize: "14px" }}>
            Pushkar Enterprises is a trusted manufacturer of plastic safety eyes, 
            toy noses, and plush toy accessories. Supplying bulk orders across India and worldwide.
          </p>
        </div>

       

        {/* 🔥 CONTACT */}
        <div className="footer-contact" style={{ marginTop: "15px" }}>
          <p>📍 Delhi, India</p>
          <p>📞 +91 7982155490</p>
          <p>&copy; 2026 Pushkar Enterprises</p>
        </div>

      </div>

      {/* 🔥 WHATSAPP LEAD BUTTON */}
      <div className="whatsapp-container">
        <a
          href="https://wa.me/917982155490?text=Hello%20I%20want%20to%20buy%20plastic%20safety%20eyes%20in%20bulk"
          target="_blank"
          rel="noopener noreferrer"
          className="whatsapp-link"
          onMouseEnter={handleHover}
        >
          <FontAwesomeIcon icon={faWhatsapp} className="whatsapp-icon" />
        </a>

        {showTooltip && (
          <span className="whatsapp-tooltip">{currentMessage}</span>
        )}

        {hoverMessage && (
          <span className="whatsapp-tooltip">
            Chat for bulk orders
          </span>
        )}
      </div>

    </footer>
  );
};

export default Footer;